const windowOpenerPostMessage = (
  message: Record<string, unknown>,
  performClose: boolean = true,
) => {
  if (window?.opener) {
    window.opener.postMessage(message, '*')
    if (performClose === true) {
      window.close()
    }
  }
}

export { windowOpenerPostMessage }
